import { render, staticRenderFns } from "./RangeFilter.vue?vue&type=template&id=180bea74&"
import script from "./RangeFilter.vue?vue&type=script&lang=js&"
export * from "./RangeFilter.vue?vue&type=script&lang=js&"
import style0 from "./RangeFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports